import { Modal } from "antd";
import { RightCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function RecipeEditExceptionModal({
  open,
  title,
  dependentSetMenuOrders = [],
  dependentSetMenus = [],
  dependentOrders = [],
  onConfirm = () => {},
  onCancel = () => {},
}) {
  const navigate = useNavigate();

  function onHandleOrderUrl(orderId) {
    // navigate(`/order/${orderId}/details?pageNo=1&sourcePage=RECIPE_EDIT`)
    return navigate(`/order/${orderId}/details`);
  }

  return (
    <Modal
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Ok"
      cancelText="Close"
      width={1000}
      centered
      title={<span className="text-lg font-p_medium">{title}</span>}
      okButtonProps={{
        style: { backgroundColor: "black", color: "white", fontWeight: 700 },
      }}
      cancelButtonProps={{
        style: { backgroundColor: "#FCBD10", color: "black", fontWeight: 700 },
      }}
    >
      <div className="my-3 space-y-3">
        {dependentSetMenus.length > 0 && (
          <div>
            <h1 className="text-sm font-p_semibold py-2">Setmenus</h1>
            {dependentSetMenus.map((setMenu) => (
              <div
                key={setMenu.id}
                className="border border-[#FCBD10] rounded-lg px-3 py-2 mb-2 cursor-pointer flex justify-between items-center"
              >
                <p>{setMenu.name}</p>
                <RightCircleOutlined />
              </div>
            ))}
          </div>
        )}

        {dependentOrders.length > 0 && (
          <div>
            <h1 className="text-sm font-p_semibold py-2">Orders</h1>
            {dependentOrders.map((order) => (
              <div
                key={order.id}
                className="border border-[#FCBD10] rounded-lg px-3 py-2 mb-2 cursor-pointer flex justify-between items-center"
                onClick={() => onHandleOrderUrl(order.id)}
              >
                <p>{order.orderNumber}</p>
                <RightCircleOutlined />
              </div>
            ))}
          </div>
        )}

        {dependentSetMenuOrders.length > 0 && (
          <div>
            <h1 className="text-sm font-p_semibold py-2">Set Menu Orders</h1>
            {dependentSetMenuOrders.map((order, idx) => (
              <div
                key={`setMenuOrder-${idx}`}
                className="border border-[#FCBD10] rounded-lg px-3 py-2 mb-2 cursor-pointer flex justify-between items-center"
              >
                <p>{`Set menu orders ${idx + 1}`}</p>
                <RightCircleOutlined />
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
